import { Component, h } from 'preact';

interface GenericSearchInputProps {
  value?: string;
  placeholder?: string;
  resultCount?: number;
  onInput?: (evt: Event) => void;
}

export class GenericSearchInput extends Component<GenericSearchInputProps> {
  render(props: GenericSearchInputProps) {
    return (
      <div className="hi-gensearchin">
        <div className="hi-gensearchin__icon">
          <i className="fas fa-search" />
        </div>
        
        <input
          className="hi-gensearchin__input"
          placeholder={ props.placeholder }
          value={ props.value }
          onInput={ props.onInput } />
        {
          props.resultCount ? 
            <span className="hi-gensearchin__result-count">
              { `- ${props.resultCount} results found` }
            </span> : null
        }
      </div>
    );
  }
}
